import request from '../helpers/request'

export default {
  getComments: async ({ id, offset, onlyWithMedia, endpoint }) => {
    const params = {}

    if (id) params.productId = id
    if (onlyWithMedia) params.onlyWithMedia = onlyWithMedia
    if (offset) params.offset = offset

    const { data } = await request.get(endpoint, { params })

    return data
  },
  postComment: async ({ formData, endpoint }) => {
    const headers = {
      'Content-Type': 'multipart/form-data'
    }

    const { data } = await request.post(endpoint, formData, { headers })

    return data
  }
}
